module.exports = "<div class=label ng-class=\"'label-' + (type || 'default')\" ng-transclude></div> ";